import React, { Fragment } from "react";
import { $Project } from "./Site.styles";

function composeFilteredProjects(projects, matches, shouldFilter) {
  if (!shouldFilter) {
    return {
      included: projects,
      excluded: [],
    };
  }

  const included = projects.filter((project) =>
    matches.has(project.project_pk)
  );
  const excluded = projects.filter(
    (project) => !matches.has(project.project_pk)
  );
  return {
    included,
    excluded,
  };
}

const Projects = ({
  projects,
  matches,
  onClick,
  active,
  shouldFilter = false,
}) => {
  const { included, excluded } = composeFilteredProjects(
    projects,
    matches,
    shouldFilter
  );

  return (
    <Fragment>
      {included.map((project) => (
        <$Project
          // disabled={project.project_pk === active.project_pk}
          active={project.project_pk === active.project_pk}
          onClick={onClick(project.project_pk)}
          key={project.project_pk}
        >
          <span>{project.project_name}</span>{" "}
          <span>{project.sites.length}</span>
        </$Project>
      ))}
      {excluded.map((project) => (
        <$Project
          disabled
          noMatch
          onClick={onClick(project)}
          key={project.project_pk}
        >
          {project.project_name}
        </$Project>
      ))}
    </Fragment>
  );
};

export default Projects;
